import React from 'react';
import { number, func } from 'prop-types';
import { useSelector } from 'react-redux';
import { wrapTextForSVG } from 'utils/utils';
import DynamicIcon from 'components/DynamicIcon';

Title.propTypes = {
  floorLevel: number,
  rotate: number,
  onTitleClick: func,
};

function Title({ floorLevel, rotate, onTitleClick }) {
  const targetProperty = floorLevel + 'F';
  const titleState = useSelector((state) => state.titleCoors);
  const title = titleState[targetProperty] || [];


  return (
    <>
      {title.map(({ title: shopTitle, position, cx, cy, rotate: titleRotate, id }, index) => {
        const baseX = position?.x ?? cx;
        const baseY = position?.y ?? cy;
        const x = baseX;
        const y = baseY;
        const lines = wrapTextForSVG(shopTitle);
        const handleClick = () => {
          if (onTitleClick) {
            onTitleClick({ title: shopTitle, id, position, cx, cy, floorLevel });
          }
        };

        return (
          <g key={index} onClick={handleClick} style={{ cursor: onTitleClick ? 'pointer' : 'default' }}>
            <text
              x={x}
              y={y}
              fontSize={floorLevel === 1 ? "5" : "6"}
              fill="black"
              fontWeight={500}
              textAnchor="middle"
              dominantBaseline="middle"
              transform={`rotate(${titleRotate || rotate}, ${x}, ${y})`}
            >
              {lines.map((line, lineIndex) => (
                <tspan
                  key={lineIndex}
                  x={x}
                  dy={lineIndex === 0 ? 0 : '1.0em'}
                  textAnchor="middle"
                >
                  {line}
                </tspan>
              ))}
            </text>
          </g>
        );
      })}
    </>
  );
}

export default Title;
